import { YoutubeBroadcast, YoutubeBroadcastVideo } from '../../youtube-broadcast-types';
import { LocaleRelativeTime } from '@mi-front/ui';
import { Box, Typography } from '@mui/material';
import { YoutubeBroadcastPeakViewers } from '../shared/YoutubeBroadcastPeakViewers';

interface YoutubeBroadcastCardMetadataProps {
  broadcast: YoutubeBroadcast;
}

/** Peak viewers and relative start time shown below the title on broadcast cards. */
export function YoutubeBroadcastCardMetadata({ broadcast }: YoutubeBroadcastCardMetadataProps) {
  return (
    <Box
      sx={{
        mt: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        flexWrap: 'wrap',
      }}
    >
      <YoutubeBroadcastPeakViewers peakViewers={broadcast.peakViewers} />
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ '&::first-letter': { textTransform: 'capitalize' } }}
        title={new Date(broadcast.streamStartedAt).toLocaleString()}
      >
        <LocaleRelativeTime value={broadcast.streamStartedAt} />
      </Typography>
    </Box>
  );
}
